import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { CustomMainContent, DropDownFilterDates } from '../../../components'
import CardNumber from '../../../components/common/NewUi/CardNumber'
import CardProgress from '../../../components/common/NewUi/CardProgress'
import Meanings from '../../../components/common/NewUi/Meanings'
import { onGetAllAlumsByGroups } from '../../../api'
import { Dropdown, Space } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import { CardBarChar } from '../../../components/common/NewUi/CardBarChar'
import { CardBarCharSimiVR } from '../../../components/common/NewUi/CardBarCharSimiVR'
import { CardBarRadarSimiAR } from '../../../components/common/NewUi/CardBarRadarSimiAR'
import RankingSimiAR from '../../../components/common/NewUi/RankingSimiAR'
const baseResponseCorrect = {
    "001._Desafío_1_Invernal_-_Saluda": "A",
        "002._Desafío_1_Invernal_-_Escucha_y_pregunta": "A",
        "003._Desafío_1_Invernal_-_Escucha_y_pregunta": "A",
        "004._Desafío_1_Invernal_-_Resuelve_su_necesidad": "A",
        "005._Desafío_1_Invernal_-_Resuelve_su_necesidad": "A",
        "006._Desafío_1_Invernal_-_Cierre_de_venta": "A",
        "007._Desafío_1_Invernal_-_Cierre_de_venta": "A",
        "008._Desafío_1_Invernal_-_Agradece": "A",

    "001._Desafío_1_Analgesia_-_Saluda": "A",
    "002._Desafío_1_Analgesia_-_Escucha_y_pregunta": "A",
    "003._Desafío_1_Analgesia_-_Escucha_y_pregunta": "A",
    "004._Desafío_1_Analgesia_-_Resuelve_su_necesidad": "A",
    "005._Desafío_1_Analgesia_-_Resuelve_su_necesidad": "A",
    "006._Desafío_1_Analgesia_-_Cierre_de_venta": "A",
    "007._Desafío_1_Analgesia_-_Cierre_de_venta": "A",
    "008._Desafío_1_Analgesia_-_Agradece": "A",

        "001._Desafío_1_Multivitamínico_-_Saluda": "A",
        "002._Desafío_1_Multivitamínico_-_Escucha_y_pregunta": "A",
        "003._Desafío_1_Multivitamínico_-_Escucha_y_pregunta": "A",
        "004._Desafío_1_Multivitamínico_-_Resuelve_su_necesidad": "A",
        "005._Desafío_1_Multivitamínico_-_Resuelve_su_necesidad": "A",
        "006._Desafío_1_Multivitamínico_-_Cierre_de_venta": "A",
        "007._Desafío_1_Multivitamínico_-_Cierre_de_venta": "A",
        "008._Desafío_1_Multivitamínico_-_Agradece": "A",

        "001._Desafío_1_Gastro_-_Saluda": "A",
        "002._Desafío_1_Gastro_-_Escucha_y_pregunta": "A",
        "003._Desafío_1_Gastro_-_Escucha_y_pregunta": "A",
        "004._Desafío_1_Gastro_-_Resuelve_su_necesidad": "A",
        "005._Desafío_1_Gastro_-_Resuelve_su_necesidad": "A",
        "006._Desafío_1_Gastro_-_Cierre_de_venta": "A",
        "007._Desafío_1_Gastro_-_Cierre_de_venta": "A",
        "008._Desafío_1_Gastro_-_Agradece": "A",

        "001._Desafío_2_3x2_-_Saluda": "A",
        "002._Desafío_2_3x2_-_Escucha_y_pregunta": "A",
        "003._Desafío_2_3x2_-_Escucha_y_pregunta": "A",
        "004._Desafío_2_3x2_-_Resuelve_su_necesidad": "A",
        "005._Desafío_2_3x2_-_Cierre_de_venta": "A",
        "006._Desafío_2_3x2_-_Cierre_de_venta": "A",
        "007._Desafío_2_3x2_-_Agradece": "A",

        "001._Desafío__3_-_Saluda": "A",
        "002._Desafío__3_-_Escucha_y_pregunta": "A",
        "003._Desafío__3_-_Escucha_y_pregunta": "A",
        "004._Desafío__3_-_Resuelve_su_necesidad": "A",
        "005._Desafío__3_-_Resuelve_su_necesidad": "A",
        "006._Desafío__3_-_Cierre_de_venta": "A",
        "007._Desafío__3_-_Cierre_de_venta": "A",
        "008._Desafío__3_-_Agradece": "A",


}

export const LearningDashboardSimiVr = () => {
    const [usersAndProgress, setUsersAndProgress] = useState({
        totalUsers: 0,
        activeUsers: 0,
        inactiveUsers: 0,
        finishedUsers: 0,
    })
    const [infoModules, setinfoModules] = useState({
        "001._Desafío_1_Invernal_-_Saluda": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "002._Desafío_1_Invernal_-_Escucha_y_pregunta": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "003._Desafío_1_Invernal_-_Escucha_y_pregunta": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "004._Desafío_1_Invernal_-_Resuelve_su_necesidad": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "005._Desafío_1_Invernal_-_Resuelve_su_necesidad": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "006._Desafío_1_Invernal_-_Cierre_de_venta": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "007._Desafío_1_Invernal_-_Cierre_de_venta": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "008._Desafío_1_Invernal_-_Agradece": { intents: 0, corrects: 0, fails: 0, time: 0 },

        "001._Desafío_1_Analgesia_-_Saluda": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "002._Desafío_1_Analgesia_-_Escucha_y_pregunta": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "003._Desafío_1_Analgesia_-_Escucha_y_pregunta": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "004._Desafío_1_Analgesia_-_Resuelve_su_necesidad": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "005._Desafío_1_Analgesia_-_Resuelve_su_necesidad": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "006._Desafío_1_Analgesia_-_Cierre_de_venta": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "007._Desafío_1_Analgesia_-_Cierre_de_venta": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "008._Desafío_1_Analgesia_-_Agradece": { intents: 0, corrects: 0, fails: 0, time: 0 },

        "001._Desafío_1_Multivitamínico_-_Saluda": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "002._Desafío_1_Multivitamínico_-_Escucha_y_pregunta": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "003._Desafío_1_Multivitamínico_-_Escucha_y_pregunta": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "004._Desafío_1_Multivitamínico_-_Resuelve_su_necesidad": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "005._Desafío_1_Multivitamínico_-_Resuelve_su_necesidad": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "006._Desafío_1_Multivitamínico_-_Cierre_de_venta": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "007._Desafío_1_Multivitamínico_-_Cierre_de_venta": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "008._Desafío_1_Multivitamínico_-_Agradece": { intents: 0, corrects: 0, fails: 0, time: 0 },

        "001._Desafío_1_Gastro_-_Saluda": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "002._Desafío_1_Gastro_-_Escucha_y_pregunta": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "003._Desafío_1_Gastro_-_Escucha_y_pregunta": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "004._Desafío_1_Gastro_-_Resuelve_su_necesidad": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "005._Desafío_1_Gastro_-_Resuelve_su_necesidad": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "006._Desafío_1_Gastro_-_Cierre_de_venta": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "007._Desafío_1_Gastro_-_Cierre_de_venta": { intents: 0, corrects: 0, fails: 0, time: 0 },
        "008._Desafío_1_Gastro_-_Agradece": { intents: 0, corrects: 0, fails: 0, time: 0 },

        "001._Desafío_2_3x2_-_Saluda":{ intents: 0, corrects: 0, fails: 0, time: 0 },
        "002._Desafío_2_3x2_-_Escucha_y_pregunta":{ intents: 0, corrects: 0, fails: 0, time: 0 },
        "003._Desafío_2_3x2_-_Escucha_y_pregunta":{ intents: 0, corrects: 0, fails: 0, time: 0 },
        "004._Desafío_2_3x2_-_Resuelve_su_necesidad":{ intents: 0, corrects: 0, fails: 0, time: 0 },
        "005._Desafío_2_3x2_-_Cierre_de_venta":{ intents: 0, corrects: 0, fails: 0, time: 0 },
        "006._Desafío_2_3x2_-_Cierre_de_venta":{ intents: 0, corrects: 0, fails: 0, time: 0 },
        "007._Desafío_2_3x2_-_Agradece":{ intents: 0, corrects: 0, fails: 0, time: 0 },

        "001._Desafío__3_-_Saluda":{ intents: 0, corrects: 0, fails: 0, time: 0 },
        "002._Desafío__3_-_Escucha_y_pregunta":{ intents: 0, corrects: 0, fails: 0, time: 0 },
        "003._Desafío__3_-_Escucha_y_pregunta":{ intents: 0, corrects: 0, fails: 0, time: 0 },
        "004._Desafío__3_-_Resuelve_su_necesidad":{ intents: 0, corrects: 0, fails: 0, time: 0 },
        "005._Desafío__3_-_Resuelve_su_necesidad":{ intents: 0, corrects: 0, fails: 0, time: 0 },
        "006._Desafío__3_-_Cierre_de_venta":{ intents: 0, corrects: 0, fails: 0, time: 0 },
        "007._Desafío__3_-_Cierre_de_venta":{ intents: 0, corrects: 0, fails: 0, time: 0 },
        "008._Desafío__3_-_Agradece":{ intents: 0, corrects: 0, fails: 0, time: 0 },
        
    })
    const [grupsInfo, setgrupsInfo] = useState({});
    const [groupSelected, setGroupSelected] = useState("TODOS");
    const { arrayData } = useSelector(state => state.table);
    const [responseRanking, setResponseRanking] = useState([]);
    const { groups } = useSelector((state) => state.vrlSlice);
    const [datesFilter, setDatesFilter] = useState({
        start: "Wed Jan 01 2025 00:00:00 GMT-0600 (hora estándar central)",
        end: "Tue Dec 30 2025 23:59:59 GMT-0600 (hora estándar central)"
    })

    useEffect(() => {
        const getDataFormated = async () => {

            // users 
            let grupsInfo = {}
            let users = 0
            const grups = await onGetAllAlumsByGroups(groups)
            grups.forEach(grup => {
                grupsInfo[grup.group] = {
                    "001._Desafío_1_Invernal_-_Saluda": 0,
                    "002._Desafío_1_Invernal_-_Escucha_y_pregunta": 0,
                    "003._Desafío_1_Invernal_-_Escucha_y_pregunta": 0,
                    "004._Desafío_1_Invernal_-_Resuelve_su_necesidad": 0,
                    "005._Desafío_1_Invernal_-_Resuelve_su_necesidad": 0,
                    "006._Desafío_1_Invernal_-_Cierre_de_venta": 0,
                    "007._Desafío_1_Invernal_-_Cierre_de_venta": 0,
                    "008._Desafío_1_Invernal_-_Agradece": 0,

                    "001._Desafío_1_Analgesia_-_Saluda": 0,
                    "002._Desafío_1_Analgesia_-_Escucha_y_pregunta": 0,
                    "003._Desafío_1_Analgesia_-_Escucha_y_pregunta": 0,
                    "004._Desafío_1_Analgesia_-_Resuelve_su_necesidad": 0,
                    "005._Desafío_1_Analgesia_-_Resuelve_su_necesidad": 0,
                    "006._Desafío_1_Analgesia_-_Cierre_de_venta": 0,
                    "007._Desafío_1_Analgesia_-_Cierre_de_venta": 0,
                    "008._Desafío_1_Analgesia_-_Agradece": 0,

                    "001._Desafío_1_Multivitamínico_-_Saluda":0,
"002._Desafío_1_Multivitamínico_-_Escucha_y_pregunta":0,
"003._Desafío_1_Multivitamínico_-_Escucha_y_pregunta":0,
"004._Desafío_1_Multivitamínico_-_Resuelve_su_necesidad":0,
"005._Desafío_1_Multivitamínico_-_Resuelve_su_necesidad":0,
"006._Desafío_1_Multivitamínico_-_Cierre_de_venta":0,
"007._Desafío_1_Multivitamínico_-_Cierre_de_venta":0,
"008._Desafío_1_Multivitamínico_-_Agradece":0,
"001._Desafío_1_Gastro_-_Saluda":0,
"002._Desafío_1_Gastro_-_Escucha_y_pregunta":0,
"003._Desafío_1_Gastro_-_Escucha_y_pregunta":0,
"004._Desafío_1_Gastro_-_Resuelve_su_necesidad":0,
"005._Desafío_1_Gastro_-_Resuelve_su_necesidad":0,
"006._Desafío_1_Gastro_-_Cierre_de_venta":0,
"007._Desafío_1_Gastro_-_Cierre_de_venta":0,
"008._Desafío_1_Gastro_-_Agradece":0,

"001._Desafío_2_3x2_-_Saluda":0,
"002._Desafío_2_3x2_-_Escucha_y_pregunta":0,
"003._Desafío_2_3x2_-_Escucha_y_pregunta":0,
"004._Desafío_2_3x2_-_Resuelve_su_necesidad":0,
"005._Desafío_2_3x2_-_Cierre_de_venta":0,
"006._Desafío_2_3x2_-_Cierre_de_venta":0,
"007._Desafío_2_3x2_-_Agradece":0,

"001._Desafío__3_-_Saluda":0,
"002._Desafío__3_-_Escucha_y_pregunta":0,
"003._Desafío__3_-_Escucha_y_pregunta":0,
"004._Desafío__3_-_Resuelve_su_necesidad":0,
"005._Desafío__3_-_Resuelve_su_necesidad":0,
"006._Desafío__3_-_Cierre_de_venta":0,
"007._Desafío__3_-_Cierre_de_venta":0,
"008._Desafío__3_-_Agradece":0,

                    // "T3L3": 0,
                    // "T4L1": 0,
                    // "T4L2": 0,
                    // "T4L3": 0,
                }
                if (groupSelected === grup.group || groupSelected === "TODOS") {
                    users += grup.students.length
                }
            })
            setUsersAndProgress(actual => ({ ...actual, totalUsers: users }));

            // Convertir las fechas a objetos Date para comparación correcta
            const filterDateResponse = arrayData.filter(item => {
                const itemDate = new Date(item.Fecha_y_hora);
                const startDate = new Date(datesFilter.start);
                const endDate = new Date(datesFilter.end);
                return itemDate >= startDate && itemDate <= endDate;
            });

            const unicsResponses = new Set(filterDateResponse.map(obj => obj.matricula));
            // console.log(arrayData)            
            const unicsResponsesFinishd = new Set(
                filterDateResponse
                    .filter(obj => obj["008._Desafío__3_-_Agradece"] != null)
                    .map(obj => obj.matricula)
            );
            setUsersAndProgress(actual => ({ ...actual, activeUsers: unicsResponses.size - unicsResponsesFinishd.size }));
            setUsersAndProgress(actual => ({ ...actual, inactiveUsers: users - unicsResponses.size }));
            setUsersAndProgress(actual => ({ ...actual, finishedUsers: unicsResponsesFinishd.size }));


            const filtrados = filterDateResponse.filter(obj => unicsResponsesFinishd.has(obj.matricula));
            console.log(filtrados)
            let userFormatedRanking = []

            let infoModules = {
                "001._Desafío_1_Invernal_-_Saluda": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "002._Desafío_1_Invernal_-_Escucha_y_pregunta": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "003._Desafío_1_Invernal_-_Escucha_y_pregunta": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "004._Desafío_1_Invernal_-_Resuelve_su_necesidad": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "005._Desafío_1_Invernal_-_Resuelve_su_necesidad": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "006._Desafío_1_Invernal_-_Cierre_de_venta": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "007._Desafío_1_Invernal_-_Cierre_de_venta": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "008._Desafío_1_Invernal_-_Agradece": { intents: 0, corrects: 0, fails: 0, time: 0 },

                "001._Desafío_1_Analgesia_-_Saluda": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "002._Desafío_1_Analgesia_-_Escucha_y_pregunta": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "003._Desafío_1_Analgesia_-_Escucha_y_pregunta": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "004._Desafío_1_Analgesia_-_Resuelve_su_necesidad": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "005._Desafío_1_Analgesia_-_Resuelve_su_necesidad": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "006._Desafío_1_Analgesia_-_Cierre_de_venta": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "007._Desafío_1_Analgesia_-_Cierre_de_venta": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "008._Desafío_1_Analgesia_-_Agradece": { intents: 0, corrects: 0, fails: 0, time: 0 },

                "001._Desafío_1_Multivitamínico_-_Saluda": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "002._Desafío_1_Multivitamínico_-_Escucha_y_pregunta": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "003._Desafío_1_Multivitamínico_-_Escucha_y_pregunta": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "004._Desafío_1_Multivitamínico_-_Resuelve_su_necesidad": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "005._Desafío_1_Multivitamínico_-_Resuelve_su_necesidad": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "006._Desafío_1_Multivitamínico_-_Cierre_de_venta": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "007._Desafío_1_Multivitamínico_-_Cierre_de_venta": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "008._Desafío_1_Multivitamínico_-_Agradece": { intents: 0, corrects: 0, fails: 0, time: 0 },
                
                "001._Desafío_1_Gastro_-_Saluda": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "002._Desafío_1_Gastro_-_Escucha_y_pregunta": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "003._Desafío_1_Gastro_-_Escucha_y_pregunta": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "004._Desafío_1_Gastro_-_Resuelve_su_necesidad": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "005._Desafío_1_Gastro_-_Resuelve_su_necesidad": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "006._Desafío_1_Gastro_-_Cierre_de_venta": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "007._Desafío_1_Gastro_-_Cierre_de_venta": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "008._Desafío_1_Gastro_-_Agradece": { intents: 0, corrects: 0, fails: 0, time: 0 },
                
                "001._Desafío_2_3x2_-_Saluda": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "002._Desafío_2_3x2_-_Escucha_y_pregunta": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "003._Desafío_2_3x2_-_Escucha_y_pregunta": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "004._Desafío_2_3x2_-_Resuelve_su_necesidad": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "005._Desafío_2_3x2_-_Cierre_de_venta": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "006._Desafío_2_3x2_-_Cierre_de_venta": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "007._Desafío_2_3x2_-_Agradece": { intents: 0, corrects: 0, fails: 0, time: 0 },

                "001._Desafío__3_-_Saluda": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "002._Desafío__3_-_Escucha_y_pregunta": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "003._Desafío__3_-_Escucha_y_pregunta": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "004._Desafío__3_-_Resuelve_su_necesidad": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "005._Desafío__3_-_Resuelve_su_necesidad": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "006._Desafío__3_-_Cierre_de_venta": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "007._Desafío__3_-_Cierre_de_venta": { intents: 0, corrects: 0, fails: 0, time: 0 },
                "008._Desafío__3_-_Agradece": { intents: 0, corrects: 0, fails: 0, time: 0 },
                
            }

            // const trash = []
            // let algomas = 0
            filtrados.forEach(response => {
                // if (response["Inicio_4._¿Por_qué_es_importante_contar_con_anaqueles_bien_acomodados_y_frenteados?"]
                //     // || response["Final_1._¿Número_de_anaqueles_considerados_en_farmacia?"]
                // ) {

                //     trash.push(response)
                // }
                let fails = 0
                let corrects = 0
                Object.keys(baseResponseCorrect).forEach(key => {
                    if (response["001._Desafío_1_Gastro_-_Saluda"] ) {
                        console.log(response)
                    }
                    if (response[key] ) {
                        infoModules[key].time = infoModules[key].time + parseInt(response.tiempo_total.split(' ')[0])
                        infoModules[key].intents += 1
                        //   if (key === "T4L1") {
                        //       console.log(response)
                        //   }
                        if (response[key] === baseResponseCorrect[key]) {
                            infoModules[key].corrects += 1
                            corrects += 1
                            grupsInfo[response.grupo][key] += 1
                            //   if (key === "T2L1") {
                            //       console.log(parseInt(response[key]))
                            //   }
                        }
                        else {
                            //   if (key === "T2L1") {
                            //   console.log(parseInt(baseResponseCorrect[key]), parseInt(response[key]))
                            //   }
                            infoModules[key].fails += 1
                            fails += 1
                        }
                    }
                })
                userFormatedRanking.push({ ...response, fails, corrects })
            })
            // console.log(trash)
            setgrupsInfo(grupsInfo)
            console.log(infoModules)
            //   console.log("---")
            const resultado = {};
            userFormatedRanking.forEach(item => {
                const matricula = item.matricula;

                if (!resultado[matricula]) {
                    // Si no existe aún, inicializa el objeto
                    resultado[matricula] = { ...item };
                    resultado[matricula].corrects = Number(item.corrects) || 0;
                    resultado[matricula].fails = Number(item.fails) || 0;
                } else {
                    // Si ya existe, suma los corrects y fails y reemplaza el resto
                    resultado[matricula].corrects += Number(item.corrects) || 0;
                    resultado[matricula].fails += Number(item.fails) || 0;
                    resultado[matricula] = {
                        ...resultado[matricula],
                        ...item,
                        corrects: resultado[matricula].corrects,
                        fails: resultado[matricula].fails
                    };
                }
            });
            //   console.log(Object.values(resultado)
            //       .filter(item => item.corrects !== 0 || item.fails !== 0)
            //       .sort((a, b) => a.fails - b.fails))
            setResponseRanking(Object.values(resultado)
                .filter(item => item.corrects !== 0 || item.fails !== 0)
                .sort((a, b) => a.fails - b.fails))

            setinfoModules(infoModules)

        }
        getDataFormated()
    }, [groupSelected, groups, datesFilter])

    const getDataPerModules = (modules, multiplo = 1) => {
        let promedioTimeDivider =  1
        let promedio = 0
        let errorsPromedio = 0
        let timePromedio = 0
        modules.forEach(module => {
            if(parseInt(infoModules[module].intents) === 0){
                return
            }
            promedio += ((parseInt(infoModules[module].corrects) / parseInt(infoModules[module].intents)) * multiplo)
            errorsPromedio += ((parseInt(infoModules[module].fails) / parseInt(infoModules[module].intents)) * multiplo)
            timePromedio += parseInt(infoModules[module].time) / parseInt(infoModules[module].intents) * multiplo
        })
        return { promedio: Math.round(promedio), errorsPromedio: Math.round(errorsPromedio), timePromedio: timePromedio / promedioTimeDivider }
    }

    return (
        <div style={{ background: "rgba(27, 20, 100, 0.1)" }} className='w-full h-screen overflow-scroll'>
            <CustomMainContent>
                <div className="flex w-full min-w-[450px] h-full pr-4">
                    <div className="w-full ">
                        <div className="flex py-3 gap-x-4 pr-6 items-center justify-between">
                            <p className="text-[#686868] text-sm font-semibold font-inter">Usuarios y avance</p>
                            <section className='flex gap-4 text-black'>
                                <DropDownFilterDates
                                    callBack={(start, end, _, { startDate, endDate }, beforeText) => {
                                        setDatesFilter({ start, end })
                                    }}
                                />
                                <Dropdown
                                    className='cursor-pointer'
                                    menu={{
                                        items: groups.map(group => ({ key: group._id, label: group.name })),
                                        onClick: ({ key }) => { console.log(key) }
                                    }}
                                >
                                    <Space>
                                        <p className="text-black "> {groupSelected}</p>
                                        <DownOutlined />
                                    </Space>
                                </Dropdown>
                            </section>
                        </div>
                        <div className="flex gap-x-4 overflow-x-auto pb-2 ">
                            <CardNumber newUsers={10} title={"Total de usuarios"} value={usersAndProgress.totalUsers} color="text-[#282828]" />
                            <CardNumber newUsers={10} title={"Usuarios activos"} value={usersAndProgress.activeUsers} color="text-[#55AE70]" />
                            <CardNumber newUsers={10} title={"Usuarios inactivos"} value={usersAndProgress.inactiveUsers} color="text-[#AE5555]" />
                            <CardNumber newUsers={10} title={"Cursos terminados"} value={usersAndProgress.finishedUsers} color="text-[#282828]" />
                        </div>
                        <div className="flex py-3 gap-x-4 items-center">
                            <p className="text-[#686868] text-sm font-semibold">Promedio General y por Módulo</p>
                        </div>
                        <div className="flex max-w-[1040px]  gap-x-4 overflow-x-scroll  overflow-y-auto pb-2">
                            {/* <CardProgress module={"Curso total"} newUsers={100} title={"Aciertos promedio"}
                                value={getDataPerModules(["T1L1", "T1L2", "T1L3", "T2L1", "T2L2", "T2L3", "T3L1", "T3L2", "T3L3", "T4L1", "T4L2", "T4L3"]).promedio}
                                maxValue={66} color="text-[#282828]"
                                time={getDataPerModules(["T1L1", "T1L2", "T1L3", "T2L1", "T2L2", "T2L3", "T3L1", "T3L2", "T3L3", "T4L1", "T4L2", "T4L3"]).timePromedio}
                                repetitions={getDataPerModules(["T1L1", "T1L2", "T1L3", "T2L1", "T2L2", "T2L3", "T3L1", "T3L2", "T3L3", "T4L1", "T4L2", "T4L3"]).errorsPromedio}>
                            </CardProgress> */}
                            <CardProgress module={"Desafío 1 Invernal "} newUsers={100} title={"Aciertos promedio"}
                                value={getDataPerModules(["001._Desafío_1_Invernal_-_Saluda","002._Desafío_1_Invernal_-_Escucha_y_pregunta","003._Desafío_1_Invernal_-_Escucha_y_pregunta","004._Desafío_1_Invernal_-_Resuelve_su_necesidad","005._Desafío_1_Invernal_-_Resuelve_su_necesidad","006._Desafío_1_Invernal_-_Cierre_de_venta","007._Desafío_1_Invernal_-_Cierre_de_venta","008._Desafío_1_Invernal_-_Agradece"]).promedio}
                                maxValue={8} color="text-[#282828]"
                                time={getDataPerModules(["001._Desafío_1_Invernal_-_Saluda","002._Desafío_1_Invernal_-_Escucha_y_pregunta","003._Desafío_1_Invernal_-_Escucha_y_pregunta","004._Desafío_1_Invernal_-_Resuelve_su_necesidad","005._Desafío_1_Invernal_-_Resuelve_su_necesidad","006._Desafío_1_Invernal_-_Cierre_de_venta","007._Desafío_1_Invernal_-_Cierre_de_venta","008._Desafío_1_Invernal_-_Agradece"]).timePromedio}
                                repetitions={getDataPerModules(["001._Desafío_1_Invernal_-_Saluda","002._Desafío_1_Invernal_-_Escucha_y_pregunta","003._Desafío_1_Invernal_-_Escucha_y_pregunta","004._Desafío_1_Invernal_-_Resuelve_su_necesidad","005._Desafío_1_Invernal_-_Resuelve_su_necesidad","006._Desafío_1_Invernal_-_Cierre_de_venta","007._Desafío_1_Invernal_-_Cierre_de_venta","008._Desafío_1_Invernal_-_Agradece"]).errorsPromedio}>
                            </CardProgress>
                            <CardProgress module={"Desafío 1 Multivitamínico "} newUsers={100} title={"Aciertos promedio"}
                                value={getDataPerModules([
"001._Desafío_1_Multivitamínico_-_Saluda",
"002._Desafío_1_Multivitamínico_-_Escucha_y_pregunta",
"003._Desafío_1_Multivitamínico_-_Escucha_y_pregunta",
"004._Desafío_1_Multivitamínico_-_Resuelve_su_necesidad",
"005._Desafío_1_Multivitamínico_-_Resuelve_su_necesidad",
"006._Desafío_1_Multivitamínico_-_Cierre_de_venta",
"007._Desafío_1_Multivitamínico_-_Cierre_de_venta",
"008._Desafío_1_Multivitamínico_-_Agradece",
]).promedio}
                                maxValue={8} color="text-[#282828]"
                                time={getDataPerModules([
"001._Desafío_1_Multivitamínico_-_Saluda",
"002._Desafío_1_Multivitamínico_-_Escucha_y_pregunta",
"003._Desafío_1_Multivitamínico_-_Escucha_y_pregunta",
"004._Desafío_1_Multivitamínico_-_Resuelve_su_necesidad",
"005._Desafío_1_Multivitamínico_-_Resuelve_su_necesidad",
"006._Desafío_1_Multivitamínico_-_Cierre_de_venta",
"007._Desafío_1_Multivitamínico_-_Cierre_de_venta",
"008._Desafío_1_Multivitamínico_-_Agradece"]).timePromedio}
                                repetitions={getDataPerModules([
"001._Desafío_1_Multivitamínico_-_Saluda",
"002._Desafío_1_Multivitamínico_-_Escucha_y_pregunta",
"003._Desafío_1_Multivitamínico_-_Escucha_y_pregunta",
"004._Desafío_1_Multivitamínico_-_Resuelve_su_necesidad",
"005._Desafío_1_Multivitamínico_-_Resuelve_su_necesidad",
"006._Desafío_1_Multivitamínico_-_Cierre_de_venta",
"007._Desafío_1_Multivitamínico_-_Cierre_de_venta",
"008._Desafío_1_Multivitamínico_-_Agradece"]).errorsPromedio}>
                            </CardProgress>
                            <CardProgress module={"Desafío 1 Gastro "} newUsers={100} title={"Aciertos promedio"}
                                value={getDataPerModules([
                                        "001._Desafío_1_Gastro_-_Saluda",
                                        "002._Desafío_1_Gastro_-_Escucha_y_pregunta",
                                        "003._Desafío_1_Gastro_-_Escucha_y_pregunta",
                                        "004._Desafío_1_Gastro_-_Resuelve_su_necesidad",
                                        "005._Desafío_1_Gastro_-_Resuelve_su_necesidad",
                                        "006._Desafío_1_Gastro_-_Cierre_de_venta",
                                        "007._Desafío_1_Gastro_-_Cierre_de_venta",
                                        "008._Desafío_1_Gastro_-_Agradece",]).promedio}
                                maxValue={8} color="text-[#282828]"
                                time={getDataPerModules([
                                        "001._Desafío_1_Gastro_-_Saluda",
                                        "002._Desafío_1_Gastro_-_Escucha_y_pregunta",
                                        "003._Desafío_1_Gastro_-_Escucha_y_pregunta",
                                        "004._Desafío_1_Gastro_-_Resuelve_su_necesidad",
                                        "005._Desafío_1_Gastro_-_Resuelve_su_necesidad",
                                        "006._Desafío_1_Gastro_-_Cierre_de_venta",
                                        "007._Desafío_1_Gastro_-_Cierre_de_venta",
                                        "008._Desafío_1_Gastro_-_Agradece"]).timePromedio}
                                repetitions={getDataPerModules([
                                        "001._Desafío_1_Gastro_-_Saluda",
                                        "002._Desafío_1_Gastro_-_Escucha_y_pregunta",
                                        "003._Desafío_1_Gastro_-_Escucha_y_pregunta",
                                        "004._Desafío_1_Gastro_-_Resuelve_su_necesidad",
                                        "005._Desafío_1_Gastro_-_Resuelve_su_necesidad",
                                        "006._Desafío_1_Gastro_-_Cierre_de_venta",
                                        "007._Desafío_1_Gastro_-_Cierre_de_venta",
                                        "008._Desafío_1_Gastro_-_Agradece"]).errorsPromedio}>
                            </CardProgress>

                            <CardProgress module={"Desafío 1 Analgesia"} newUsers={100} title={"Aciertos promedio"}
                                value={getDataPerModules([
                                    "001._Desafío_1_Analgesia_-_Saluda",
                                    "002._Desafío_1_Analgesia_-_Escucha_y_pregunta",
                                    "003._Desafío_1_Analgesia_-_Escucha_y_pregunta",
                                    "004._Desafío_1_Analgesia_-_Resuelve_su_necesidad",
                                    "005._Desafío_1_Analgesia_-_Resuelve_su_necesidad",
                                    "006._Desafío_1_Analgesia_-_Cierre_de_venta",
                                    "007._Desafío_1_Analgesia_-_Cierre_de_venta",
                                    "008._Desafío_1_Analgesia_-_Agradece",]).promedio}
                                maxValue={8} color="text-[#282828]"
                                time={getDataPerModules([
                                    "001._Desafío_1_Analgesia_-_Saluda",
                                    "002._Desafío_1_Analgesia_-_Escucha_y_pregunta",
                                    "003._Desafío_1_Analgesia_-_Escucha_y_pregunta",
                                    "004._Desafío_1_Analgesia_-_Resuelve_su_necesidad",
                                    "005._Desafío_1_Analgesia_-_Resuelve_su_necesidad",
                                    "006._Desafío_1_Analgesia_-_Cierre_de_venta",
                                    "007._Desafío_1_Analgesia_-_Cierre_de_venta",
                                    "008._Desafío_1_Analgesia_-_Agradece"]).timePromedio}
                                repetitions={getDataPerModules([
                                    "001._Desafío_1_Analgesia_-_Saluda",
                                    "002._Desafío_1_Analgesia_-_Escucha_y_pregunta",
                                    "003._Desafío_1_Analgesia_-_Escucha_y_pregunta",
                                    "004._Desafío_1_Analgesia_-_Resuelve_su_necesidad",
                                    "005._Desafío_1_Analgesia_-_Resuelve_su_necesidad",
                                    "006._Desafío_1_Analgesia_-_Cierre_de_venta",
                                    "007._Desafío_1_Analgesia_-_Cierre_de_venta",
                                    "008._Desafío_1_Analgesia_-_Agradece"]).errorsPromedio}>
                            </CardProgress>

                            <CardProgress module={"Desafío 2 3x2"} newUsers={100} title={"Aciertos promedio"}
                                value={getDataPerModules([
                                        "001._Desafío_2_3x2_-_Saluda",
                                        "002._Desafío_2_3x2_-_Escucha_y_pregunta",
                                        "003._Desafío_2_3x2_-_Escucha_y_pregunta",
                                        "004._Desafío_2_3x2_-_Resuelve_su_necesidad",
                                        "005._Desafío_2_3x2_-_Cierre_de_venta",
                                        "006._Desafío_2_3x2_-_Cierre_de_venta",
                                        "007._Desafío_2_3x2_-_Agradece",
                                        ]).promedio}
                                maxValue={7} color="text-[#282828]"
                                time={getDataPerModules([
                                        "001._Desafío_2_3x2_-_Saluda",
                                        "002._Desafío_2_3x2_-_Escucha_y_pregunta",
                                        "003._Desafío_2_3x2_-_Escucha_y_pregunta",
                                        "004._Desafío_2_3x2_-_Resuelve_su_necesidad",
                                        "005._Desafío_2_3x2_-_Cierre_de_venta",
                                        "006._Desafío_2_3x2_-_Cierre_de_venta",
                                        "007._Desafío_2_3x2_-_Agradece",
                                        ]).timePromedio}
                                repetitions={getDataPerModules([
                                        "001._Desafío_2_3x2_-_Saluda",
                                        "002._Desafío_2_3x2_-_Escucha_y_pregunta",
                                        "003._Desafío_2_3x2_-_Escucha_y_pregunta",
                                        "004._Desafío_2_3x2_-_Resuelve_su_necesidad",
                                        "005._Desafío_2_3x2_-_Cierre_de_venta",
                                        "006._Desafío_2_3x2_-_Cierre_de_venta",
                                    "007._Desafío_2_3x2_-_Agradece",]).errorsPromedio}>
                            </CardProgress>
                            <CardProgress module={"Desafío 3 "} newUsers={100} title={"Aciertos promedio"}
                                value={getDataPerModules([
                                        "001._Desafío__3_-_Saluda",
                                        "002._Desafío__3_-_Escucha_y_pregunta",
                                        "003._Desafío__3_-_Escucha_y_pregunta",
                                        "004._Desafío__3_-_Resuelve_su_necesidad",
                                        "005._Desafío__3_-_Resuelve_su_necesidad",
                                        "006._Desafío__3_-_Cierre_de_venta",
                                        "007._Desafío__3_-_Cierre_de_venta",
                                        "008._Desafío__3_-_Agradece",
                                        ]).promedio}
                                maxValue={8} color="text-[#282828]"
                                time={getDataPerModules([
                                        "001._Desafío__3_-_Saluda",
                                        "002._Desafío__3_-_Escucha_y_pregunta",
                                        "003._Desafío__3_-_Escucha_y_pregunta",
                                        "004._Desafío__3_-_Resuelve_su_necesidad",
                                        "005._Desafío__3_-_Resuelve_su_necesidad",
                                        "006._Desafío__3_-_Cierre_de_venta",
                                        "007._Desafío__3_-_Cierre_de_venta",
                                        "008._Desafío__3_-_Agradece",
                                        ]).timePromedio}
                                repetitions={getDataPerModules([
                                        "001._Desafío__3_-_Saluda",
                                        "002._Desafío__3_-_Escucha_y_pregunta",
                                        "003._Desafío__3_-_Escucha_y_pregunta",
                                        "004._Desafío__3_-_Resuelve_su_necesidad",
                                        "005._Desafío__3_-_Resuelve_su_necesidad",
                                        "006._Desafío__3_-_Cierre_de_venta",
                                        "007._Desafío__3_-_Cierre_de_venta",
                                        "008._Desafío__3_-_Agradece",
                                        ]).errorsPromedio}>
                            </CardProgress>
                            {/* <CardProgress module={"Tema 2"} newUsers={100} title={"Aciertos promedio"}
                                value={getDataPerModules(["T2L1", "T2L2", "T2L3"]).promedio}
                                maxValue={15} color="text-[#282828]"
                                time={getDataPerModules(["T2L1", "T2L2", "T2L3"]).timePromedio}
                                repetitions={getDataPerModules(["T2L1", "T2L2", "T2L3"]).errorsPromedio}>
                            </CardProgress>
                            <CardProgress module={"Tema 3"} newUsers={100} title={"Aciertos promedio"}
                                value={getDataPerModules(["T3L1", "T3L2", "T3L3"]).promedio}
                                maxValue={16} color="text-[#282828]"
                                time={getDataPerModules(["T3L1", "T3L2", "T3L3"]).timePromedio}
                                repetitions={getDataPerModules(["T3L1", "T3L2", "T3L3"]).errorsPromedio}>
                            </CardProgress>
                            <CardProgress module={"Tema 4"} newUsers={100} title={"Aciertos promedio"}
                                value={getDataPerModules(["T4L1", "T4L2", "T4L3"]).promedio}
                                maxValue={20} color="text-[#282828]"
                                time={getDataPerModules(["T4L1", "T4L2", "T4L3"]).timePromedio}
                                repetitions={getDataPerModules(["T4L1", "T4L2", "T4L3"]).errorsPromedio}>
                            </CardProgress>
                            <CardProgress module={"inicio"} newUsers={100} title={"Aciertos promedio"}
                                value={getDataPerModules(["inicio"], 10).promedio}
                                maxValue={10} color="text-[#282828]"
                                time={getDataPerModules(["inicio"], 10).timePromedio}
                                repetitions={getDataPerModules(["inicio"], 10).errorsPromedio}>
                            </CardProgress>
                            <CardProgress module={"Final"} newUsers={100} title={"Aciertos promedio"}
                                value={getDataPerModules(["final"], 10).promedio}
                                maxValue={10} color="text-[#282828]"
                                time={getDataPerModules(["final"], 10).timePromedio}
                                repetitions={getDataPerModules(["final"], 10).errorsPromedio}>
                            </CardProgress> */}
                        </div>
                        <div className="flex py-3 gap-x-4 items-center">
                            <p className="text-[#686868] text-sm font-semibold">Datos analíticos</p>
                        </div>
                        <div className="flex gap-x-4 overflow-x-auto overflow-y-hidden">
                            <Meanings
                                meanings={[
                                    ['T1L1 : ', 'Venta ética: curar, no sólo vender'],
                                    ['T1L2 : ', '¡Nos gustan las cosas simples que funcionan!'],
                                    ['T1L3 : ', 'Nuestras familias comerciales'],
                                    ['T2L1 : ', 'Distribución de los espacios en farmacia'],
                                    ['T2L2 : ', 'Punto caliente'],
                                    ['T2L3 : ', 'Espacios de exhibiciones'],
                                    ['T3L1 : ', 'campañas y promociones'],
                                    ['T3L2 : ', 'Acomodo de anaqueles'],
                                    ['T3L3 : ', 'Exhibiciones'],
                                    ['T4L1 : ', 'Componente de anaqueles y exhibidores'],
                                    ['T4L2 : ', 'Materiales identificativos'],
                                    ['T4L3 : ', 'Boletín mensual']
                                ]}
                            />
                            <CardBarCharSimiVR
                                usersEnd={infoModules}
                                title={"Tiempo promedio por tarea"}
                                info={infoModules} ></CardBarCharSimiVR>
                            <CardBarCharSimiVR
                                usersEnd={infoModules}
                                type={"unique"}
                                title={"Número promedio de errores por tarea"}
                                info={infoModules} ></CardBarCharSimiVR>

                        </div>
                        <div className="py-6 flex gap-x-4">
                            <RankingSimiAR users={responseRanking} nameGrupo='Grupo' />
                            {/* <CardBarRadarSimiAR info={grupsInfo}></CardBarRadarSimiAR> */}

                        </div>
                    </div>
                </div>
            </CustomMainContent>
        </div>
    )
}
